module.exports = __webpack_public_path__ + "img/team_pic1.98d5154a.jpg";